import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'

import accounts from './modules/accounts'
import permissions from './modules/permissions'
import alerts from './modules/alerts'
import forms from './modules/forms'
import plan from './modules/plan'
import user from './modules/user'
import watches from './modules/watches'

import admin from './modules/admin'

import * as mutations from './modules/mutations'

Vue.use(Vuex)

let strict = process.env.NODE_ENV !== 'production'

const vuexLocal = new VuexPersistence({
	strictMode: strict,
	storage: window.localStorage
})

export default new Vuex.Store({
	strict: strict,
	modules: {
		accounts,
		permissions,
		alerts,
		forms,
		plan,
		user,
		watches,
		admin
	},
	getters: {
		canRegistWatch: state => {
			const numWatches = state.watches.data ? state.watches.data.length : 0
			const maxWatches = state.plan.data ? state.plan.data.watches : 0
			return numWatches < maxWatches
		},
		checkUserPermission: state => (user_uid, area) => {
			const token = `user|${user_uid}|${area}`
			const permission = state.permissions.data.find(element => {
				return element.area == token
			})
			return !!permission
		},
		checkGroupPermission: state => (user_uid, group_id) => {
			if (user_uid == state.user.uid) {
				return true
			}
			const token = `group|${group_id}|group`
			const permission = state.permissions.data.find(element => {
				return element.area == token
			})
			return !!permission
		},
		checkGroupWatchPermission: state => (group_id, area) => {
			const token = `group|${group_id}|${area}`
			const permission = state.permissions.data.find(element => {
				return element.area == token
			})
			return !!permission
		},
		checkWatchPermission: (state, getters) => (user_uid, watch_id, area) => {
			let result = false
			state.accounts.data.forEach(account => {
				account.watches.data.forEach(watch => {
					if (watch.id == watch_id) {
						if (account.uid == user_uid || getters.checkGroupWatchPermission(watch.group_id, area)) {
							result = true
						}
					}
				})
			})
			return result
		}
	},
	actions: {
		/*getAll ({ dispatch }, params) {
			dispatch('getPlan', params)
			//dispatch('getWatches', params)
			//dispatch('getAlerts', params)
		},*/
		clearAll ({ commit }) {
			commit(mutations.CLEAR_USER)
			commit(mutations.CLEAR_PLAN)
			commit(mutations.CLEAR_WATCHES)
			commit(mutations.CLEAR_ALERTS)
			commit(mutations.CLEAR_ACCOUNTS)
			commit(mutations.CLEAR_PERMISSIONS)
			commit(mutations.CLEAR_FORMS)
		}
	},
	mutations: {
		// this mutation **MUST** be named "RESTORE_MUTATION"
		RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION
	},
	plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js